import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { BAVBenefitActivationDialogExtension } from './extension/bav-benefit-activation-dialog.extension';
import { BavBenefitColumnsExtension } from './extension/bav-benefit-columns.extension';
import { BAVBenefitMetadataExtension } from './extension/bav-benefit-metadata.extension';
import { BAVBenefitNavigationExtension } from './extension/bav-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bav')
    .add(BenefitMetadataExtensionInterface, new BAVBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new BAVBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new BavBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new BAVBenefitActivationDialogExtension())
    .build(),
);
